const {
  zipCodeRegexNumeric,
  onlyNumericNormalize,
  SPACE
} = require('../helpers');

exports.zipCodeNormalize = (zipCode) => onlyNumericNormalize(zipCode, 5);

exports.countryDefinition = {
  country: 'Italy',
  code: 'IT',
  schema: {
    company: { label: 'Company' },
    address: { label: 'Street Address' },
    address2: { label: 'Street Address 2' },
    city: { label: 'Town', width: 0.5 },
    stateCode: { label: 'Province', width: 0.5 },
    zipCode: {
      label: 'Postal Code',
      width: 0.5,
      normalize: exports.zipCodeNormalize
    }
  },
  viewFormat: [
    ['company'],
    ['address'],
    ['address2'],
    ['zipCode', SPACE, 'city', SPACE, 'stateCode']
  ],
  formFormat: [
    ['company'],
    ['address'],
    ['address2'],
    ['zipCode', 'city'],
    ['stateCode']
  ],
  requiredFormFields: [
    { field: 'address' },
    { field: 'city' },
    { field: 'stateCode' },
    {
      field: 'zipCode',
      validationRegex: new RegExp(zipCodeRegexNumeric(5)),
      error: 'Must be 5 characters, 12345'
    }
  ]
};
